import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export const HeroSection = () => {
  return <section className="relative pt-12 pb-16 md:pt-32 md:pb-40 px-4 md:px-6 overflow-hidden bg-cream" data-id="element-54">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-55">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-beige rounded-full mix-blend-multiply filter blur-3xl opacity-50" data-id="element-56"></div>
        <div className="absolute top-40 -left-20 w-72 h-72 bg-gold rounded-full mix-blend-multiply filter blur-3xl opacity-20" data-id="element-57"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10 flex flex-col items-center text-center gap-6 md:gap-10" data-id="element-58">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-59">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-serif font-medium text-charcoal leading-tight mb-4 md:mb-6" data-id="element-60">
            ¿Y SI TUS MANOS TUVIERAN EL PODER DE{' '}
            <span className="text-gold italic" data-id="element-61">SANAR TU MENTE</span> Y CONSTRUIR
            TU LIBERTAD?
          </h1>
          <p className="text-lg md:text-xl text-charcoal/80 leading-relaxed font-light max-w-2xl mx-auto" data-id="element-62">
            Descubre el Método de "Macramé de Reconstrucción" para eliminar la
            ansiedad, recuperar tu propósito y crear un negocio artesanal
            premium en solo 30 días... incluso si nunca has tocado un hilo en tu
            vida.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative w-full max-w-md mx-auto" data-id="element-63">
          <div className="relative rounded-lg overflow-hidden shadow-floating border-8 border-white/50 bg-white" data-id="element-64">
            <img src="https://cdn.magicpatterns.com/uploads/pS2YxJEFUWvHQV7YaBgGCa/mc-mk-2.png" alt="Nudos de Esperanza Ebook" className="w-full h-auto object-cover" data-id="element-65" />
            <div className="absolute inset-0 bg-gradient-to-tr from-brown/20 to-transparent pointer-events-none" data-id="element-66"></div>
          </div>
          <div className="absolute -bottom-6 -right-6 w-24 h-24 border border-gold/30 rounded-full -z-10" data-id="element-67"></div>
          <div className="absolute -top-6 -left-6 w-32 h-32 border border-brown/10 rounded-full -z-10" data-id="element-68"></div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} data-id="element-69">
          <Button href="#oferta" className="w-full md:w-auto text-lg py-5 px-10" data-id="element-70">
            SÍ, QUIERO SANAR Y CREAR
          </Button>
        </motion.div>
      </div>
    </section>;
};